import { Contact, Status, Tenant, TenantData } from "types";
import { getRequestHeaders } from "utils";
import { TenantGroup } from "../types/TenantGroups";
import { handleRes } from "utils";

export interface GetTenantsResponse extends Response {
  tenants?: Array<Tenant>;
}
export interface GetTenantGroupsResponse extends Response {
  tenantGroups?: Array<TenantGroup>;
}
export interface GetTenantGroupResponse extends Response {
  tenantGroups?: TenantGroup;
}
export interface CreateTenantGroupResponse extends Response {
  tenantGroup?: TenantGroup;
}
export interface GetTenantResponse extends Response {
  tenant?: Tenant;
}

export interface TenantBody {
  id?: number;
  name: string;
  status: Status;
  systemID: number;
  externalID: string;
  traxeroID: string;
  accountID: string;
  tenantGroup: TenantGroup | null;
  data: TenantData;
  maxUsers: number;
  copyTenantID?: number;
  userSessionTimeOut?: number;
  contact?: Contact;
}

export const getTenants = (includeDisabled: boolean): Promise<Tenant[]> => {
  return fetch(
    `${window.USER_BASE_URL}/tenant${
      includeDisabled ? "?includeDisabled=true" : ""
    }`,
    {
      method: "GET",
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<Tenant[]>(res, 200))
    .catch((e) => {
      throw e;
    });
};

export const getTenantsNotInAGroup = (): Promise<Tenant[]> => {
  return fetch(`${window.USER_BASE_URL}/tenantGroups/0/groupless`, {
    //purposely put a 0
    method: "GET",
    ...getRequestHeaders(),
  })
    .then((res) => handleRes<Tenant[]>(res, 200))
    .catch((e) => {
      throw e;
    });
};

export const getTenantGroups = (): Promise<TenantGroup[]> => {
  return fetch(`${window.USER_BASE_URL}/tenantGroups`, {
    method: "GET",
    ...getRequestHeaders(),
  })
    .then((res) => handleRes<TenantGroup[]>(res, 200))
    .catch((e) => {
      throw e;
    });
};

export const createTenantGroups = async (
  body: string, // TenantGroup,
): Promise<CreateTenantGroupResponse> => {
  return await fetch(`${window.USER_BASE_URL}/tenantGroups`, {
    method: "POST",
    ...getRequestHeaders(),
    body,
  });
};

export const updateTenantGroup = async (
  body: string, // TenantGroup,
): Promise<CreateTenantGroupResponse> => {
  return await fetch(`${window.USER_BASE_URL}/tenantGroups`, {
    method: "PUT",
    ...getRequestHeaders(),
    body: body,
  });
};

export const getTenantGroupByID = (id: number): Promise<TenantGroup> => {
  return fetch(`${window.USER_BASE_URL}/tenantGroups/${id}`, {
    method: "GET",
    ...getRequestHeaders(),
  })
    .then((res) => handleRes<TenantGroup>(res, 200))
    .catch((e) => {
      throw e;
    });
};

export const getTenantByID = (id: number): Promise<Tenant> => {
  return fetch(`${window.USER_BASE_URL}/tenant/${id}`, {
    method: "GET",
    ...getRequestHeaders(),
  }).then((res) => handleRes<Tenant>(res, 200));
};

interface CreateTenantParams {
  body: string; // TenantBody as JSON string
  tenantGroupID: number;
}
export const createTenant = async ({
  body,
  tenantGroupID,
}: CreateTenantParams): Promise<GetTenantResponse> => {
  return await fetch(
    `${window.USER_BASE_URL}/tenantGroups/${tenantGroupID}/tenant`,
    {
      method: "POST",
      ...getRequestHeaders(),
      body,
    },
  );
};

interface UpdateTenantParams {
  body: string; // TenantBody as JSON string
  tenantID: string | number | undefined;
}
export const updateTenant = async ({
  body,
  tenantID,
}: UpdateTenantParams): Promise<Response> => {
  return await fetch(`${window.USER_BASE_URL}/tenant/${tenantID}`, {
    method: "PUT",
    ...getRequestHeaders(),
    body,
  });
};

interface UpdateTenantPublicContactAndDataParams {
  tenantID: string | number | undefined;
  body: string; // TenantPublicContactAndData as JSON string
}
export const updateTenantPublicContactAndData = async ({
  tenantID,
  body,
}: UpdateTenantPublicContactAndDataParams): Promise<Response> => {
  return await fetch(
    `${window.USER_BASE_URL}/tenant/${tenantID}/contactAndData`,
    {
      method: "PUT",
      ...getRequestHeaders(),
      body,
    },
  );
};
